import React from 'react'
import whatsappicon1 from '../Images/whatsapp-icon-logo-svgrepo-com.svg'
import './Whatsappicon.css'

function Whatsappicon() {
  return (
    <div>
      <div className='whatsapp-icon-div1'>
        <a href="https://wa.me/447510074850
" target='_blank'>
            <img src={whatsappicon1} alt="" />
        </a>
      </div>
    </div>
  )
}

export default Whatsappicon
